import {RequestedOrganizationModel} from './integration-models';
import {
    ACTIVE_INTEGRATION_STATES,
    IntegrationState
} from '../../views/admin/application-settings/models/integration-state.model';

export enum SchoolFilterType {
    ALL = 'ALL',
    ACTIVE = 'ACTIVE',
    PENDING = 'PENDING',
    INACTIVE = 'INACTIVE',
    WITHERROR = 'witherror'
    // APPROVED = 'approved',
    // WITHOUTSYNC = 'withoutsync'
}

export enum SyncModeModel {
    IN = 'IN',
    OUT = 'OUT',
    SYNC = 'SYNC'
}

export enum OrgType {
    ROOT = 'root',
    APP_VENDOR = 'app_vendor',
    COUNTY = 'county',
    DISTRICT = 'district',
    SCHOOL = 'school',
    INDEPENDENT_SCHOOL = 'independent_school'
}

export class DirectoryOrganization {
    orgGuid: number;
    guid: string;
    orgType: OrgType;
    parentOrg: number;
    parentOrgGuid: string;
    orgInstitutionId: string;
    ncesId: string;
    localId: string;
    crmId: string;
    url: string;
    orgName: string;
    createdAt: Date;
    lastModified: Date;
    region: string;
    country: string;
    countryName: string;
    state: string;
    stateName: string;
    postalCode: string;
    contactName: string;
    contactTitle: string;
    contactPhone: string;
    contactEmail: string;
    isSelected: boolean;
    isDeleting: boolean;
    isDeleteDisabled: boolean;
    externalIds: any; // { 'sisId': sisId }
    host: string;
    constructor(
        orgGuid: string = '',
        orgName: string = '',
        orgType: OrgType = null
    ) {
    }
}

export class DistrictProfileModel {

    districtGuid: string;
    districtName: string;
    institutionDataSourceModel: InstitutionDataSourceModel[];

    schoolsTotal: number;
    schoolsShared: number;
    schoolsInvalid: number;
    schoolsSkipped: number;
    schoolsPendingApprove: number;

    studentsTotal: number;
    studentsShared: number;
    studentsInvalid: number;
    studentsSkipped: number;

    schoolAdminsTotal: number;
    schoolAdminsShared: number;
    schoolAdminsInvalid: number;
    schoolAdminsSkipped: number;

    staffTotal: number;
    staffShared: number;
    staffInvalid: number;
    staffSkipped: number;

    calendarsTotal: number;
    calendarsShared: number;
    calendarsInvalid: number;
    calendarsSkipped: number;

    coursesTotal: number;
    coursesShared: number;
    coursesInvalid: number;
    coursesSkipped: number;

    sectionsTotal: number;
    sectionsShared: number;
    sectionsInvalid: number;
    sectionsSkipped: number;

    groupsTotal: number;
    groupsShared: number;
    groupsInvalid: number;
    groupsSkipped: number;

    contactsTotal: number;
    contactsShared: number;
    contactsInvalid: number;
    contactsSkipped: number;

    enrollmentsTotal: number;
    enrollmentsShared: number;
    enrollmentsInvalid: number;
    enrollmentsSkipped: number;

    lineItemsTotal: number;
    lineItemsShared: number;
    lineItemsInvalid: number;
    lineItemsSkipped: number;

    assessmentLineItemsTotal: number;
    assessmentLineItemsShared: number;
    assessmentLineItemsInvalid: number;
    assessmentLineItemsSkipped: number;

    resultsTotal: number;
    resultsShared: number;
    resultsInvalid: number;
    resultsSkipped: number;

    assessmentResultsTotal: number;
    assessmentResultsShared: number;
    assessmentResultsInvalid: number;
    assessmentResultsSkipped: number;

    scoreScalesTotal: number;
    scoreScalesShared: number;
    scoreScalesInvalid: number;
    scoreScalesSkipped: number;

    categoriesTotal: number;
    categoriesShared: number;
    categoriesInvalid: number;
    categoriesSkipped: number;

    resourcesTotal: number;
    resourcesShared: number;
    resourcesInvalid: number;
    resourcesSkipped: number;

    applicationGuid: string;
    syncMode: SyncModeModel;
    dataLastChanged: Date;

    epochSecond: number;
    nano: number;

    syncTimestamp: {nano: 0; epochSecond: 0};
    nextSyncTimestamp: Date;
    expirationTs: Date;

    errorsTotal: number;
    schoolsWithErrorsCount: number;

    // extra from UI
    syncStatus: IntegrationState;
    status: IntegrationState;
    isDistrictSuspendImportByRollOverPeriod: boolean;
    type: string;
    profileType: string;

    region: string;
    country: string;
    state: string;

    static isActivated(district: DistrictProfileModel): boolean {
        return ACTIVE_INTEGRATION_STATES.indexOf(district.syncStatus) > -1;
    }

    static isExpired(district: DistrictProfileModel): boolean {
        return [IntegrationState.EXPIRED, IntegrationState.EXPIRED_AND_SUSPENDED].indexOf(district.syncStatus) > -1;
    }

    constructor () {

    }
}

export class SchoolProfileModel {

    schoolGuid: string;
    schoolName: string;
    localId: string;

    studentsTotal: number;
    studentsShared: number;
    studentsInvalid: number;
    studentsSkipped: number;

    schoolAdminsTotal: number;
    schoolAdminsShared: number;
    schoolAdminsInvalid: number;
    schoolAdminsSkipped: number;

    staffTotal: number;
    staffShared: number;
    staffInvalid: number;
    staffSkipped: number;

    calendarsTotal: number;
    calendarsShared: number;
    calendarsInvalid: number;
    calendarsSkipped: number;

    coursesTotal: number;
    coursesShared: number;
    coursesInvalid: number;
    coursesSkipped: number;

    sectionsTotal: number;
    sectionsShared: number;
    sectionsInvalid: number;
    sectionsSkipped: number;

    groupsTotal: number;
    groupsShared: number;
    groupsInvalid: number;
    groupsSkipped: number;

    contactsTotal: number;
    contactsShared: number;
    contactsInvalid: number;
    contactsSkipped: number;

    enrollmentsTotal: number;
    enrollmentsShared: number;
    enrollmentsInvalid: number;
    enrollmentsSkipped: number;

    lineItemsTotal: number;
    lineItemsShared: number;
    lineItemsInvalid: number;
    lineItemsSkipped: number;

    assessmentLineItemsTotal: number;
    assessmentLineItemsShared: number;
    assessmentLineItemsInvalid: number;
    assessmentLineItemsSkipped: number;

    resultsTotal: number;
    resultsShared: number;
    resultsInvalid: number;
    resultsSkipped: number;

    assessmentResultsTotal: number;
    assessmentResultsShared: number;
    assessmentResultsInvalid: number;
    assessmentResultsSkipped: number;

    scoreScalesTotal: number;
    scoreScalesShared: number;
    scoreScalesInvalid: number;
    scoreScalesSkipped: number;

    categoriesTotal: number;
    categoriesShared: number;
    categoriesInvalid: number;
    categoriesSkipped: number;

    resourcesTotal: number;
    resourcesShared: number;
    resourcesInvalid: number;
    resourcesSkipped: number;

    applicationGuid: string;
    syncMode: SyncModeModel;

    dataLastChanged: {nano: 0; epochSecond: 0};
    epochSecond: number;
    nano: number;

    syncTimestamp: {nano: 0; epochSecond: 0};
    nextSyncTimestamp: Date;
    expirationTs: Date;

    isInvalidSchool: boolean;
    errorsTotal: number;
    totalInvalid: number;

    // extra from UI
    syncStatus: IntegrationState;
    status: IntegrationState;
    type: string;
    districtGuid: string;
    districtName: string;

    checked: boolean;
    modifiedBy: RequestedOrganizationModel;
    profileType: string;
    independed = false;

    isLoading: boolean;
    [key: string]: boolean | any; // task.sourceTypes i.e. Student, Contact, Staff, Schooladmin

    static isActivated(school: SchoolProfileModel): boolean {
        return ACTIVE_INTEGRATION_STATES.indexOf(school.syncStatus) > -1;
    }

    static getTotalInvalid(school: SchoolProfileModel): number {
        return school.studentsInvalid + school.schoolAdminsInvalid + school.staffInvalid + school.calendarsInvalid
             + school.coursesInvalid + school.sectionsInvalid + school.groupsInvalid + school.contactsInvalid + school.enrollmentsInvalid
             + (school.isInvalidSchool ? 1 : 0);
    }

    constructor () {

    }
}

export class InstitutionDataSourceModel {
    dataSourceFriendlyName: string;
    icon: string;
    lastExecutionDate: Date;
    nextExecutionDate: Date;
}

export const TASK_TO_PROFILE_MAPPING = {
    'School': 'schools',
    'Student': 'students',
    'Contact': 'contacts',
    'Staff': 'staff',
    'Course': 'courses',
    'Roster': 'sections',
    'RosterStudentEnrollment': 'enrollments',
    'Calendar': 'calendars',
    'Group': 'groups',
    'SchoolAdmin': 'schoolAdmins',
    'LineItem': 'lineItems',
    'Result': 'results',
    'AssessmentLineItem': 'assessmentLineItems',
    'AssessmentResult': 'assessmentResults',
    'ScoreScale': 'scoreScales',
    'Category': 'categories',
    'Resource': 'resources'
};

export class FilterOrganization {
    orgGuid: string;
    orgId: string;
    orgName: string;
    orgType: string;
    parentOrg: number;
}

export interface Counterparty {
    guid: string;
    name: string;
}

export class IntegrationVendor implements Counterparty {
    guid: string;
    name: string;
    applicationGuid: string;
    model: DirectoryOrganization;

    static valueOf(model: DirectoryOrganization): IntegrationVendor {
        const obj = new IntegrationVendor();
        obj.model = model;
        obj.guid = model.guid;
        obj.name = model.orgName;

        return obj;
    }
}

export class IntegrationProvider implements Counterparty {

    constructor() {
    }

    guid: string;
    name: string;

    parentGuid: string;
    parentName: string;

    // applicationGuid: string;
    syncMode: SyncModeModel;

    status: IntegrationState;

    type: string;
    model: (DistrictProfileModel | SchoolProfileModel);
    independent = false;

    static valueOf(model: (DistrictProfileModel | SchoolProfileModel)): IntegrationProvider {
        const obj: IntegrationProvider = new IntegrationProvider();

        if (model.profileType === 'DISTRICT_PROFILE') {
            const d = model as DistrictProfileModel;
            obj.guid = d.districtGuid;
            obj.name = d.districtName;
            // obj.applicationGuid = d.applicationGuid;
            obj.syncMode = d.syncMode;
            obj.type = 'district';

        } else if (model.profileType === 'SCHOOL_PROFILE' || model.profileType === 'INDEPENDENT_SCHOOL_PROFILE') {
            const s = model as SchoolProfileModel;
            obj.guid = s.schoolGuid;
            obj.name = s.schoolName;
            obj.parentGuid = s.districtGuid;
            obj.parentName = s.districtName;
            // obj.applicationGuid = s.applicationGuid;
            obj.syncMode = s.syncMode;
            obj.type = 'school';
            obj.independent = model.profileType === 'INDEPENDENT_SCHOOL_PROFILE';
        }

        obj.model = model;
        return obj;
    }

    isDistrictType(): boolean {
        return this.type === 'district';
    }
    isSchoolType(): boolean {
        return this.type === 'school' && this.parentGuid !== null;
    }
    isIndependentSchoolType(): boolean {
        return this.type === 'school' && this.parentGuid === null;
    }
}

export const PROFILE_TYPE = {
    INDEPENDENT_SCHOOL_PROFILE: 'INDEPENDENT_SCHOOL_PROFILE',
    SCHOOL_PROFILE: 'SCHOOL_PROFILE'
};

export class DeletingOrganizationsProgress {

    constructor (
        public orgGuidList: Set<string> = new Set(),
        public amountOfOrgs: number = null,
        public progress: number = null) {
    }
}
